'use client'

import { Sankey, Tooltip, ResponsiveContainer } from 'recharts'
import type { SankeyPayload } from '../svs-types'
import { resolveColor } from '../color-mapping'

interface SankeyRendererProps {
  payload: SankeyPayload
}

export function SankeyRenderer({ payload }: SankeyRendererProps) {
  const { nodes, links } = payload.data

  // Build index map for Recharts Sankey (requires numeric indices)
  const nodeIndexMap = new Map<string, number>()
  nodes.forEach((n, i) => nodeIndexMap.set(n.id, i))

  const rechartsData = {
    nodes: nodes.map((n, i) => ({
      name: n.label,
      fill: resolveColor(n.color, i),
    })),
    links: links
      .filter(l => nodeIndexMap.has(l.source) && nodeIndexMap.has(l.target))
      .map(l => ({
        source: nodeIndexMap.get(l.source)!,
        target: nodeIndexMap.get(l.target)!,
        value: l.value,
      })),
  }

  return (
    <ResponsiveContainer width="100%" height={350}>
      <Sankey
        data={rechartsData}
        nodeWidth={10}
        nodePadding={24}
        margin={{ top: 10, right: 40, left: 40, bottom: 10 }}
        link={{ stroke: 'hsl(var(--muted-foreground))', strokeOpacity: 0.3 }}
      >
        <Tooltip />
      </Sankey>
    </ResponsiveContainer>
  )
}
